import React from 'react'
import HeaderEducationInvest from "../components/Header/EducationInvestHeader/EducationInvestHeader"
import PurchaseModal from '../pages/EducationPortal/LearnInvest/PurchaseModal'
import { useState } from 'react'
const EducationInvestLayout = ({ children, setShowPurchaseModal }) => {
    const [showPurchaseModal, setLocalShowPurchaseModal] = useState(false)

    // If setShowPurchaseModal prop is passed (like from HOC), prefer it
    const setter = setShowPurchaseModal || setLocalShowPurchaseModal


    return (
        <div className='educationInvest-layout'>
            <div className="d-md-block position-sticky top-0 z-index-9">
                <HeaderEducationInvest setShowPurchaseModal={setter} />
            </div>
            <div className='educationInvest-main'>
                <div className="educationInvest-content">{React.cloneElement(children, { setShowPurchaseModal: setter })}</div>
            </div>
            {showPurchaseModal && (
                <PurchaseModal setShowPurchaseModal={setter} />
            )}
        </div>
    )
}

export default EducationInvestLayout